import { unstable_OneTimePasswordField as OneTimePasswordField } from "radix-ui";

const OtpInput = ({ value, onValueChange, index }) => {
  return (
    <OneTimePasswordField.Input
      key={index}
      className="flex h-12 w-12 items-center justify-center rounded-md border border-gray-200 
                 text-red-500 text-lg text-center outline-none transition 
                 focus:border-red-500 selection:bg-transparent"
    />
  );
};

export default OtpInput;
